/**
 * 全局状态，不添加namespaced命名空间
 */
import login from '@finance/login'

export default {
  state: {
    loading: false, // loading显示状态
    containerClass: '', // container Class
    userData: {}
  },
  mutations: {
    showLoading(state) {
      state.loading = true
    },
    hideLoading(state) {
      state.loading = false
    },
    setContainerClass(state, containerClass) {
      state.containerClass = containerClass
    },
    updateUserData(state, playload) {
      state.userData = playload
    },
    updateUserLoginStatus(state, val) {
      state.userData.isLogin = val
    },
  },
  actions: {
    getUserData() {
      login.login({
        type: login.loginTypes.silent, // 登录类型【login.loginTypes.normal:正常登录（默认）, .force:强制登录, .silent:静默登录】
        success: ({ isLogin = false }) => {
          const info = {}
          this.commit('updateUserData', { isLogin, info })
        },
      })
    },
  },
}



// WEBPACK FOOTER //
// ./src/stores/modules/common.js